import { RobotIdentity } from './types';

export const getRobotIdentity = async (
  robotIp: string | undefined,
  identity_id: string
): Promise<RobotIdentity> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  if (identity_id === undefined) {
    throw new Error('Identity ID is undefined');
  }

  const response = await fetch(
    `http://${robotIp}/identities/identity/${identity_id}`,
    {
      method: 'GET',
    }
  );

  if (!response.ok) {
    throw new Error(
      `Get Robot Identity returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const getRobotIdentities = async (
  robotIp: string | undefined
): Promise<RobotIdentity[]> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/identities`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Get Robot Identities returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const createRobotIdentity = async (
  robotIp: string | undefined,
  identity: Partial<RobotIdentity>
): Promise<RobotIdentity> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  if (identity === undefined) {
    throw new Error('Identity to be created is undefined');
  }

  const response = await fetch(`http://${robotIp}/identities/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(identity),
  });

  if (!response.ok) {
    throw new Error(
      `Create Robot Identities returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const updateRobotIdentity = async (
  robotIp: string | undefined,
  identity_id: string,
  identity: Partial<RobotIdentity>
): Promise<RobotIdentity> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  if (identity_id === undefined) {
    throw new Error('Identity ID is undefined');
  }

  if (identity === undefined) {
    throw new Error('Identity to be updated is undefined');
  }

  const response = await fetch(
    `http://${robotIp}/identities/identity/${identity_id}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(identity),
    }
  );

  if (!response.ok) {
    throw new Error(
      `Update Robot Identities returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const deleteRobotIdentity = async (
  robotIp: string | undefined,
  identity_id: string
): Promise<void> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  if (identity_id === undefined) {
    throw new Error('Identity ID is undefined');
  }

  const response = await fetch(
    `http://${robotIp}/identities/identity/${identity_id}`,
    {
      method: 'DELETE',
    }
  );

  if (!response.ok) {
    throw new Error(
      `Delete Robot Identities returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }
};

export const createRobotFaceEmbeddings = async (
  robotIp: string | undefined,
  name: string
): Promise<RobotIdentity> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  if (!name) {
    throw new Error('Name is invalid');
  }

  const response = await fetch(
    `http://${robotIp}/identities/create/face-embeddings`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name }),
    }
  );

  if (!response.ok) {
    throw new Error(
      `Create Robot Face Embeddings returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  const res = await response.json();
  if (!res?.new_identity?.uuid) {
    throw new Error(
      `Create Robot Face Embeddings returned an invalid identity: ${res.new_identity}`
    );
  }

  return res.new_identity;
};

export const updateRobotFaceEmbeddings = async (
  robotIp: string | undefined,
  identity_id: string
): Promise<void> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  if (identity_id === undefined) {
    throw new Error('Identity ID is undefined');
  }

  const response = await fetch(
    `http://${robotIp}/identities/identity/${identity_id}/face-embeddings`,
    {
      method: 'PUT',
    }
  );

  if (!response.ok) {
    throw new Error(
      `Update Robot Face Embeddings returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }
};

export const deleteRobotFaceEmbeddings = async (
  robotIp: string | undefined,
  identity_id: string
): Promise<void> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  if (identity_id === undefined) {
    throw new Error('Identity ID is undefined');
  }

  const response = await fetch(
    `http://${robotIp}/identities/identity/${identity_id}/face-embeddings`,
    {
      method: 'DELETE',
    }
  );

  if (!response.ok) {
    throw new Error(
      `Delete Robot Face Embeddings returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }
};
